const TermOfService = () => {
  return ( <>
  {/* LEGAL BANNER */}
  <div className="legal-banner" style={{ paddingTop: 72 }}>
    <h1>Terms of Service for Digylax Pvt Ltd</h1>
    <p>PLEASE READ THESE TERMS CAREFULLY. BY ACCESSING OR USING THE SERVICES, YOU AGREE TO ALL TERMS AND CONDITIONS HEREIN.</p>
  </div>
    
  {/* MAIN CONTENT */}
  <main className="legal-layout">
    <div className="legal-container">
      <header className="legal-header">
        <h2>Agreement Details</h2>
        <p className="last-updated">Effective Date: June 20, 2025 | Last Updated: June 20, 2025</p>
      </header>

      <section className="legal-content">
        <p>
          By using the Services (MDM, HRMS, and CRM) provided by Digylax Pvt Ltd ("Digylax," "we," or "us"),
          you consent to be legally bound by these Terms of Service ("Terms").
        </p>

        <h3>I. General Terms and Acceptance</h3>

        <h4>1. Parties to the Agreement</h4>
        <ol>
          <li>These Terms form a legal and binding agreement between you and Digylax Pvt Ltd
            (address: N8, Souvenir, Kalapatti Road, Coimbatore - 641014, India).
          </li>
          <li>You confirm you are at least 18 years of age and possess the full legal authority (as HR,
            Admin, or Employee) to enter into and bind your organization to this agreement.
          </li>
        </ol>

        <h4>2. Service Description</h4>
        <ol>
          <li>Digylax provides cloud-based HRMS, CRM, and MDM solutions on a subscription basis.</li>
          <li>Services are provided "AS IS" and are paid-subscription only. Digylax does not
            offer free trials; however, demonstrations may be available to prospective clients.
            Digylax reserves the sole right to update, modify, or discontinue any feature or
            component of the Services at any time without liability.
          </li>
        </ol>

        <h4>3. User Obligations and Restricted Regions</h4>
        <ol>
          <li>You warrant that you will use the Services exclusively for internal, legitimate
            business purposes of your organization.
          </li>
          <li>There are currently no restricted geographical regions for the use of our Services.</li>
        </ol>

        <h3>II. Usage and Content</h3>

        <h4>4. User-Generated Content</h4>
        <ol>
          <li>You may upload and submit content (documents, comments, data, etc., "User Content").</li>
          <li>You own your User Content. However, you grant Digylax a worldwide, perpetual,
            non-exclusive, royalty-free, sublicensable, and transferable license to use, host, store,
            copy, and display your User Content solely for the purpose of operating, maintaining,
            securing, and improving the Services.
          </li>
        </ol>

        <h4>5. Responsibilities and Restrictions</h4>
        <ol>
          <li><strong>Data Responsibility:</strong> You are solely responsible for the accuracy, legality, quality, and
            content of all User Content provided under your account.
          </li>
          <li><strong>Prohibited Use:</strong> You must not use the Services for any illegal activity, to transmit
            malicious software, or in a way that interferes with the integrity or performance of the
            platform.
          </li>
          <li><strong>Immediate Termination Right:</strong> Digylax reserves the right to terminate access immediately
            and without prior notice for severe security violations, breaches of intellectual property rights,
            or any activity that poses an immediate threat to the platform or other users.
          </li>
        </ol>

        <h4>6. Third-Party Integrations and Services</h4>
        <ol>
          <li>We may offer integrations with third-party applications.</li>
          <li>We are not responsible for the functionality, data security, or contractual terms of these
            third-party services. Your use is governed solely by their respective policies.
          </li>
        </ol>

        <h3>III. Payments, Billing, and Termination</h3>

        <h4>7. Payment and Billing</h4>
        <ol>
          <li>We accept Banking transactions like NEFT, RTGS. All fees are due in advance for the
            subscription term purchased.
          </li>
          <li><strong>Non-Refundable Fees:</strong> All fees paid to Digylax are strictly non-refundable and are payments
            for access to the Services, regardless of your organization's usage or termination status.
          </li>
          <li><strong>Renewal and Changes:</strong> Digylax may change the Service fees or subscription terms upon
            30 days written notice. Specific terms governing auto-renewal (if applicable) and cancellation
            methods will be detailed in the Billing Policy and must be explicitly agreed upon at the time of
            purchase or renewal.
          </li>
        </ol>

        <h4>8. Termination</h4>
        <ol>
          <li><strong>Suspension:</strong> Digylax may suspend your access temporarily for a suspected breach, illegal
            activity, or extended periods of inactivity (defined as 90 consecutive days without login). We
            will provide prior notice wherever reasonably possible.
          </li>
          <li><strong>Right to Respond:</strong> You will be given a reasonable opportunity to respond to the concerns
            regarding the suspension by contacting us within the period specified in the notification.
          </li>
          <li><strong>Termination by Digylax (for Cause):</strong> Digylax reserves the right to permanently terminate
            access if a breach is confirmed and not remedied, or if immediate termination is legally warranted.
            Upon termination by Digylax for cause, all prepaid fees are immediately forfeited.
          </li>
          <li><strong>Termination by User:</strong> You may terminate your subscription according to Clause 7(iii).
            Upon any termination, your right to use the Services ends immediately, and our data retention
            policies apply.
          </li>
        </ol>

        <h3>IV. Warranties, Liability, and Governing Law</h3>

        <h4>9. Disclaimer of Warranty</h4>
        <p>
          The Services are provided "AS IS" and "AS AVAILABLE," without any warranty, express or implied.
          Digylax disclaims all warranties, including merchantability, fitness for a particular purpose, and
          non-infringement. We do not guarantee that the Services will be uninterrupted, error-free, or fully secure.
        </p>

        <h4>10. Limitation of Liability (Liability Limitation Clause)</h4>
        <ol>
          <li>To the maximum extent permitted by Indian law, Digylax, its affiliates, or employees shall not
            be liable for any indirect, incidental, special, punitive, or consequential damages (including,
            but not limited to, lost profits or data loss) resulting from:
            <ol type="a">
              <li>your use or inability to use the Services;</li>
              <li>unauthorized access to our servers; or</li>
              <li>third-party conduct related to the Services.</li>
            </ol>
          </li>
          <li><strong>Maximum Liability:</strong> In no event shall the aggregate total liability of Digylax exceed the
            total amount you paid us during the twelve (12) months immediately preceding the event
            giving rise to the claim.
          </li>
        </ol>

        <h4>11. Governing Law and Jurisdiction</h4>
        <ol>
          <li>These Terms shall be governed and construed exclusively in accordance with the laws of India.</li>
          <li>Any disputes arising out of or relating to these Terms or the Services shall be subject to the
            exclusive jurisdiction of the competent courts located in Chennai, Tamil Nadu, India.
          </li>
        </ol>
        <div className="contact-info">
          <p><strong>Contact Information</strong></p>
          <p>For legal or privacy queries, contact us via the designated contact email: <a href="mailto:support@digylax.com" className="link-dark">support@digylax.com</a>.</p>
        </div>
      </section>
    </div>
  </main>
  </> );
}
 
export default TermOfService;